module.exports = __webpack_public_path__ + "img/diapositiva-4-5.c91850ab.png";